import { ConfirmModalComponent } from '../../common/confirm-modal/confirm-modal.component';
import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { TooltipComponent } from '../../../modules/mapfre-design-library/src/lib/_components/section-components/tooltip/tooltip.component';
import { HeaderComponent } from '../../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { BillingStuffService } from '@services/billing-stuff.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, TooltipComponent, MapfreButtonComponent, ConfirmModalComponent],
  selector: 'app-enroll-data-doesnot-match',
  templateUrl: './enroll-data-doesnot-match.component.html',
  styleUrls: ['./enroll-data-doesnot-match.component.scss']
})
export class EnrollDataDoesnotMatchComponent implements OnInit {
  enrollDetailsList: any;
  displayConfirmModal: boolean;
  enrollData: any;
  constructor(
    private billingStuffService: BillingStuffService,
    private router: Router
  ) { 
    this.displayConfirmModal = false;
  }

  onCloseConfirmModal() {
    this.displayConfirmModal = false;
  }
  cancel() {
    this.displayConfirmModal = true;
  }
  tryAgain() {
    this.router.navigate(['/paperless'], {
      queryParams: { retryAttempt: true }
    });
  }
  getEnrollData() {
    this.billingStuffService.getEnrollData().subscribe(enrollData => {
      this.enrollDetailsList = this.billingStuffService.getEnrollDetails(enrollData);
    })
  }
  ngOnInit(): void {
    this.getEnrollData();
  }
}

